var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-login-footer"},[_c('div',{staticClass:"account-login-footer__title"},[_vm._v("\n        Don't have an account?\n      ")]),_vm._v(" "),_c('span',{staticClass:"account-login-footer__link",on:{"click":function($event){$event.preventDefault();return _vm.onCreateAccount($event)}}},[_vm._v("\n        Create an Account\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac999fea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/account-login/footer/footer.vue
// module id = Cwec
// module chunks = 0